import firebase from "firebase";
import GeoFire from "geofire";
var firebaseRef = firebase.database().ref("localizacaoUsuarios");
var geoFire = new GeoFire(firebaseRef);

export const getUserPosition = () => {
  return dispatch => {
    navigator.geolocation.getCurrentPosition(position => {
      dispatch({
        type: "location",
        payload: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      });
      return getLocationOnGeoFire(
        position.coords.latitude,
        position.coords.longitude,
        dispatch
      );
    });
  };
};

const getLocationOnGeoFire = (lat, lng, dispatch) => {
  var geoQuery = geoFire.query({
    center: [lat, lng],
    radius: 50.5
  });
  var novaLista = [];
  geoQuery.on("key_entered", (key, location, distance) => {
    var obj = { key, lat: location[1], lng: location[0], distance };
    novaLista.push(obj);
  });
  dispatch({ type: "getUserPosition", payload: novaLista });
  dispatch({ type: "loadUsers", payload: "done" });
};



// WEBPACK FOOTER //
// ./src/redux/actions/getUserPosition.js